// === App.js ===
import React from 'react';
import MusicGame from './MusicGame';
import './MusicGame.css';

function App() {
  return (
    <div className="App">
      <MusicGame />
    </div>
  );
}

export default App;

